import React from "react";
import DButton from "../DButton";
const Pagination = ({
    nextPage,
    previousPage,
    pagesNumber,
    canPreviousPage,
    canNextPage,
    pageIndex,
    gotoPage,
    icon,
}) => {
    const start =
        pageIndex - 1 < 0
            ? 0
            : pageIndex >= pagesNumber.length - 1
            ? pageIndex - 2
            : pageIndex - 1;
    const end = start + 3;
    const btnStyle = "w-[35px] h-[35px] md:w-[40px] md:h-[40px] rounded-[50%]";
    const hoverEffect = "hover:bg-primary-color-500 hover:text-white  ";

    return (
        <div className="flex">
            <DButton
                onClick={previousPage}
                disabled={!canPreviousPage}
                varient="outlined"
                className={`${btnStyle} ${
                    canPreviousPage ? hoverEffect : ""
                } flex justify-center items-center  mr-2`}
            >
                {icon.chevronRight}
            </DButton>
            {pagesNumber
                .map(page => (
                    <DButton
                        key={page}
                        onClick={() => gotoPage(page)}
                        varient={pageIndex === page ? "fill" : "outlined"}
                        className={`${btnStyle} ${
                            pageIndex === page ? "text-white" : ""
                        } ${hoverEffect} mr-2`}
                    >
                        {page + 1}
                    </DButton>
                ))
                .slice(start, end)}
            <DButton
                onClick={nextPage}
                disabled={!canNextPage}
                varient="outlined"
                className={`flex justify-center items-center ${btnStyle} ${
                    canNextPage ? hoverEffect : ""
                } `}
            >
                {icon.chevronLeft}
            </DButton>
        </div>
    );
};

export default Pagination;
